import '/assets/styles/pages/amateur-band-form.scss';
import { useState } from 'react';

// Partials
import { Form, Input, FormFeedback } from '/views/partials/forms'
import Btn from '/views/partials/btn';
import InfoBox from '/views/partials/info-box';

// Services
import siteServices from '/services/site';

const AmateurBandForm = () => {
    const [feedbackData, setFeedbackData] = useState(null);
    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const submit = (formFields) => {
        setSubmitting(true);

        siteServices.submitAmateurBandForm({
            branch_id: 1,
            ...formFields,
        }).then((feedback) => {
            setFeedbackData(feedback);
            setSuccess(true)
        }).catch((feedback) => {
            setFeedbackData(feedback);
        }).finally(() => {
            setSubmitting(false);
        })
    }

	return (
		<>
            <header className="form-header">
                <div className="wrapper">
                    <h1 className="header-title">Sahne Senin Başvuru Formu</h1>
                </div>
            </header>

            <div className="form-wrap wrapper">
                <div className="form-container">
                    {success ?
                        <FormFeedback className="form-successmessage" data={feedbackData} />
                        :
                        <Form onSubmit={submit} >
                            <div className="grid-container">
                                <FormFeedback inGrid data={feedbackData} />
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            name="name"
                                            label="Sahne İsmi"
                                            validation={{
                                                required: 'Bir grup adı girmelisiniz.'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col x6">
                                        <Input
                                            disabled={submitting}
                                            name="genre"
                                            label="Müzik Türü"
                                            validation={{
                                                required: 'Bir müzik türü girmelisiniz.'
                                            }} />
                                    </div>
                                    <div className="col x6">
                                        <Input
                                            disabled={submitting}
                                            name="socialmedia"
                                            label="Sosyal Medya Hesabı"
                                            validation={{
                                                required: 'Grubun sosyal medya hesabını girmelisiniz.'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="textarea"
                                            name="experience"
                                            label="Deneyimleriniz"
                                            validation={{
                                                required: 'Grup deneyiminiz ile ilgili bir şeyler yazmalısınız.'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col no-gap-top">
                                        <InfoBox plain>
                                            Daha önce hangi etkinliklerde veya projelerde yer aldığınızı anlatın.
                                        </InfoBox>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="textarea"
                                            name="purpose"
                                            label="Amacınız"
                                            validation={{
                                                required: 'Grubun ana hedefleri ve amacı nedir?'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col no-gap-top">
                                        <InfoBox plain>
                                            Ana hedefleriniz ve amacınız nedir?
                                        </InfoBox>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="text"
                                            name="stage_energy"
                                            label="Sahnedeki enerjinizi üç kelimeyle tanımlar mısınız?"
                                            validation={{
                                                required: 'Sahnedeki enerjinizi tamamlamalısınız'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="textarea"
                                            name="stage_story"
                                            label="Sahneye çıktığınızda ne anlatmak istiyorsunuz?"
                                            validation={{
                                                required: 'Sahne anlatınızı kısaca yazmalısınız.'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="text"
                                            name="stage_requirements"
                                            label="Sahne ihtiyacınız var mı? (Backline, enstrüman, mikser vs.)" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="number"
                                            name="stage_group_size"
                                            label="Kaç kişilik bir ekiple sahne alacaksınız?"
                                            validation={{
                                                required: 'Ekip büyüklüğünüzü belirtmelisiniz.'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="text"
                                            name="previous_live_experience"
                                            label="Sizi daha önce nerelerde canlı dinledik? (Varsa link ya da mekan adı)" />
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="text"
                                            name="application_reason"
                                            label="Bu projeye neden başvuruyorsunuz?"
                                            validation={{
                                                required: 'Projeye başvurma nedeninizi belirtmelisiniz.'
                                            }} />
                                    </div>
                                </div> */}
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="text"
                                            name="record_studio_label"
                                            label="Kayıt aldığınız stüdyonun ismi nedir?"
                                            validation={{
                                                required: 'Kayıt stüdyonuzun ismini girmelisiniz.'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col x6">
                                        <Input
                                            disabled={submitting}
                                            name="spotify_link"
                                            label="Spotify Linki" />
                                    </div>
                                    <div className="col x6">
                                        <Input
                                            disabled={submitting}
                                            name="youtube_link"
                                            label="YouTube Linki" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col x6">
                                        <Input
                                            disabled={submitting}
                                            type="phone"
                                            name="phone"
                                            label="Telefon Numarası"
                                            validation={{
                                                required: 'Telefon numaranızı girmelisiniz?',
                                                phone: 'Geçerli bir telefon numarası girmelisiniz.'
                                            }} />
                                    </div>
                                    <div className="col x6">
                                        <Input
                                            disabled={submitting}
                                            name="email"
                                            label="E-Posta Adresi"
                                            validation={{
                                                required: 'E-posta adresinizi girmelisiniz?',
                                                email: 'Geçerli bir e-posta adresi girmelisiniz.'
                                            }} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Input
                                            disabled={submitting}
                                            type="textarea"
                                            name="notes"
                                            label="Ek Notlar" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col no-gap-top">
                                        <InfoBox plain>
                                            Sizin hakkınızda eklemek istediğiniz herhangi bir önemli bilgi veya not.
                                        </InfoBox>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <Btn
                                            disabled={submitting}
                                            loading={submitting}
                                            className="primary big block text-big"
                                            type="submit">
                                            Gönder
                                        </Btn>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    }
                </div>
            </div>
		</>
	)
}

export default AmateurBandForm